export function headerActions() {
    const $body = $("body");
    const $header = $(".header");
    const $mainNav = $(".header-main-nav");
    const $headerMenuOpener = $header.find(".header-menu-opener");
    const $headerSearchOpener = $header.find(".header-search-opener");
    const $headerMainNavClose = $header.find(".header-main-nav-close");
    let menuDrop = $mainNav.find(".menu-item-has-children");
    let menuFeaturedLinks = $mainNav.find(".featured-link");
    
    menuDrop.each(function () {
        $(this).find(">a").after("<button class='header-mobile-menu-opener'></button>");
    });

    $header.find(".header-main-logo").after("<ul class='header-main-nav-featured'></ul>");

    menuFeaturedLinks.each(function (i, it) {
        let clone = $(it).clone();
        $(".header-main-nav-featured").append(clone);
    });

    $headerMenuOpener.on("click", function () {
        if ($body.hasClass("main-search-opened") && window.innerWidth < 1200) {
            $body.removeClass("main-search-opened");
        } else {
            $body.addClass("main-menu-opened");
            $body.removeClass("main-search-opened");
        }
    });
    $headerSearchOpener.on("click", function () {
        if (window.innerWidth >= 1200 && $body.hasClass("main-search-opened")) {
            $body.removeClass("main-search-opened");
        } else {
            $body.addClass("main-search-opened");
        }
    });
    $headerMainNavClose.on("click", function () {
        $body.removeClass("main-menu-opened");
    });

    $body.on("click", ".header-mobile-menu-opener", function () {
        let $parent = $(this).parent();
        if (window.innerWidth < 1200 || $body.hasClass("touch")) {
            if ($parent.hasClass("active")) {
                $parent.removeClass("active").find("ul").slideUp(400);
            } else {
                menuDrop.removeClass("active").find("ul").slideUp(400);
                $parent.addClass("active").find("ul").slideDown(400);
            }
        }
    });

    function stickyHeader() {
        let top = $(document).scrollTop();
        if (top > 0) {
            $header.addClass("sticky");
        } else {
            $header.removeClass("sticky");
        }
    }

    window.addEventListener("load", () => {
        stickyHeader();
    });
    window.addEventListener("scroll", () => {
        stickyHeader();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerActions.js